/**
 * @fileoverview POST handler for the "/apps/:app_group_id/cancel_import" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCancelImportCacheKeys } from "./constants";
import type { PostAppsAppGroupIdCancelImportProps } from "./types";

export const postCancelCsvImport = reactQueryMutationAdapter(
  appsAppGroupIdCancelImportCacheKeys,
  (props: PostAppsAppGroupIdCancelImportProps): Promise<void> => {
    // manipulate props here as needed importId

    return fetch(`/apps/${props.appGroupId}/cancel_import`, "POST", props);
  }
);
